import { render, staticRenderFns } from "./SettingBank.vue?vue&type=template&id=24298594"
import script from "./SettingBank.vue?vue&type=script&lang=js"
export * from "./SettingBank.vue?vue&type=script&lang=js"
import style0 from "./SettingBank.vue?vue&type=style&index=0&id=24298594&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports